export default {
  svgData: [
    {
      id: "slide5tv",
      name: "TV",
      label: "slide5tv"
    },
    {
      id: "slide5easel1",
      name: "Easel",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-poster.jpg"
      ],
      label: "slide5easeltext"
    },
    {
      id: "slide5display1",
      name: "Display ",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_01.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_02.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_03.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_04.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_05.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_06.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_07.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_08.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_09.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_10.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_11.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_12.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_13.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_14.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_15.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_16.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_17.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_18.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_19.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_20.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_21.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_22.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_23.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_24.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_25.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_26.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_27.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/row/row-brochure_Page_28.jpg"
      ],
      label: "slide5displaylabel"
    },
    {
      id: "slide5avatar1"
    }
  ],
  slideTitle: "Property Acquisitions",
  aboutText: `
      <p class="text-justify help">
      There are state and federal regulations that Georgia DOT must follow when a project’s design requires additional right-of-way to be purchased from an impacted property. 
      </p>
      <p class="text-justify help">
      When it is determined that a property acquisition is required for a road improvement project, either a Georgia DOT staff member or a pre-qualified, third-party consultant will contact the property owner directly to discuss the impacts to their property. <u>Only property owners</u> who have potential property acquisitions are contacted.
      </p>
      <p class="text-justify help">
      Once your tour of the Property Acquisition station is complete, we invite you to visit the next station by clicking on the right arrow or selecting your station of choice from the sidebar on the right.
      </p>
    `,
  helpText: `
    <p class="text-justify help">
    Georgia DOT strives to minimize property acquisitions and displacements during a transportation project’s design phase. Unfortunately, impacts to property are sometimes unavoidable. As design progresses, Georgia DOT makes every effort to minimize the amount of right-of-way that is needed to the greatest extent possible. Learn more about Department property acquisitions by completing the following actions:
    </p>
    <ul class="text-justify help">
      <li>
      Click Georgia DOT’s <b><u>Right-of-Way Brochure</b></u> titled, <i>What Happens if Your Property is Needed for a Transportation Facility</i>.
      </li>
      <br>
      <li>
      Click the easel that outlines the <b><u>Right-of-Way Acquisition Process</b></u>.
      </li>   
      <br>
      <li>
      Click the screen to watch a <b><u>Right-of-Way Video</b></u> that provides an overview of the process from our subject matter experts.
      </li>
    </ul>
    <br>
    <p class="text-justify help">
    If you have questions as to whether your property may be impacted, reference the Concept Display (part of the Project Design station) to view current right-of-way needs for the project. As stated, the project’s design is not final and proposed right-of-way needs could change.
    </p>
    <p class="text-justify help">
    <b>Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out. To return to the project website, select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i> icon. </b>
    </p>  
    `
};
